import { useState } from 'react';

import GenericPropertyInput from '../../../FlowDesigner/Components/Inputs/GenericPropertyInput';
import OperationPickerDialog from '../../../FlowDesigner/Components/Inputs/OperationPickerDialog';
import { OperationRefModel } from '../../../FlowDesigner/Models/DomainServiceModel';
import InputContentChip from './InputContentChip';

type OperationsInputProps = {
	operations: OperationRefModel[] | undefined;
	onOperationsChange: (operations: OperationRefModel[] | undefined) => void;
};

export default function OperationsInput({ operations, onOperationsChange }: OperationsInputProps) {
	const [open, setOpen] = useState(false);

	return (
		<>
			<GenericPropertyInput value={operations} onValueChange={onOperationsChange} onOpen={() => setOpen(true)}>
				{operations && operations.length > 0 && <InputContentChip label={`${operations.length} allowed operation${operations.length === 1 ? '' : 's'}`} />}
			</GenericPropertyInput>
			<OperationPickerDialog open={open} setOpen={setOpen} operationRefs={operations} onOperationRefsChange={onOperationsChange} multiple />
		</>
	);
}
